<template>
    <div class="width-full">

        <v-container fluid grid-list-xl class="general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-assessments bg-color">
                <v-layout row wrap class="assessment-list-page-content page-content">
                    <v-flex xl8 md8 sm8 xs12 align-start>
                        <h2 class="page-title">{{text('api.summary.list.assessments')}}</h2>
                    </v-flex>
                    <v-flex v-if="getUserData && getUserData.visibilityGroupMember === true" xl4 md4 sm4 xs12>

                        <v-text-field
                            prepend-icon="search"
                            type="text"
                            :placeholder="text('api.summary.assessment.list.placeholder.text')"
                            :value="getMsitat"
                            @keyup.enter="submitSearchByMsitat"
                            solo
                            clearable
                            @focus="addColorBorder()"
                            @blur="removeColorBorder()"
                            ref="msitat"
                            color="primary"
                            style="border: 1px solid #D4D6D7; box-shadow: none !important;"
                            class="msitat-search component-bg-color-important"
                        ></v-text-field>

                    </v-flex>

                    <v-flex xs12 class="assessment-list">
                        <v-card class="assessment-list-card component-bg-color-important" v-if="getTranslationTexts && translatedHeaders">

                            <v-data-table
                                :headers="translatedHeaders"
                                :items="getAssessmentList"
                                :pagination.sync="pagination"
                                :total-items="getAssessmentListTotalLength"
                                :loading="getIsAssessmentListDataLoading"
                                :rows-per-page-items="rowsPerPageDropdownOptions"
                                :rows-per-page-text="text('api.summary.list.pagination.rowsPerPage')"
                                class="assessment-list-table-container elevation-1"
                            >

                                <template slot="headers" slot-scope="props">
                                    <tr>
                                        <th v-for="header in props.headers"
                                            :key="header.value"
                                            :class="[
                                                header.value !== '' ? 'column sortable' : '',
                                                pagination.descending ? 'desc' : 'asc',
                                                header.value === pagination.sortBy ? 'active' : ''
                                            ]"

                                            @click="changeSort(header.value)"
                                            scope="col"
                                        >
                                            <v-icon  v-if="header.value !== ''" color="primary" small class="float-right assessment-table-arrow">arrow_upward</v-icon>
                                            {{ header.text }}
                                        </th>
                                    </tr>
                                    <tr class="assessment-list-search-criteria-row bg-color">
                                        <th scope="col" v-for="(header, index) in props.headers" :key="`filter-cell-${header.value}`" >

                                            <div v-if="getSearchCriteria.hasOwnProperty(header.value)">

                                                <!-- For Date filter, we have an input field with date picker... -->
                                                <v-menu v-if="header.value === 'date'"
                                                        :close-on-content-click="false"
                                                        v-model="isOpenSearchDateCalendar"
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px">
                                                    <v-text-field slot="activator"
                                                                  v-model="searchDate"
                                                                  :label="text('api.search.label')"
                                                                  readonly
                                                                  color="primary"
                                                                  :class="{'is-empty': (getSearchCriteria[header.value].length === 0)}"
                                                                  :append-icon="'clear'"
                                                                  :append-icon-cb="() => { clearSearchFieldValue(header.value); }"
                                                    ></v-text-field>
                                                    <v-date-picker v-model="searchDateFormattedForDatepicker"
                                                                   @input="isOpenSearchDateCalendar = false"
                                                                   no-title
                                                                   color="primary"
                                                    ></v-date-picker>
                                                </v-menu>

                                                <!-- ... but for the rest of columns, we use text inputs to filter content. -->
                                                <v-text-field
                                                    v-else
                                                    :value="getSearchCriteria[header.value]"
                                                    @input="applySearchFieldChangeDebounced(header.value, $event)"
                                                    @keyup.enter="submitSearch()"
                                                    :label="text('api.search.label')"
                                                    :class="{'is-empty': (getSearchCriteria[header.value].length === 0)}"
                                                    :append-icon="'clear'"
                                                    :append-icon-cb="() => { clearSearchFieldValue(header.value); }"
                                                >
                                                </v-text-field>

                                            </div>

                                        </th>
                                    </tr>
                                </template>

                                <template slot="items" slot-scope="props">
                                    <tr :class="{'last-clicked': getLastClickedAssessmentId === props.item.id}">
                                        <td class="assessment-id-cell">
                                            <span @click="goToSummaryPage(props.item)" >
                                                {{ props.item.token }}
                                            </span>
                                        </td>
                                        <td>{{ props.item.date }}</td>
                                        <td>{{ props.item.productName }}</td>
                                        <td>{{ props.item.pid }}</td>
                                        <td>{{ props.item.userFirstName }}</td>
                                        <td>{{ props.item.userLastName }}</td>
                                        <td>{{ props.item.userInstitution }}</td>
                                    </tr>
                                </template>
                                <template slot="no-results">
                                    <span>&nbsp;</span>
                                </template>
                                <template slot="no-data">
                                    <div class="text-xs-center">{{text("api.summary.list.emptyList")}}</div>
                                </template>
                                <template slot="pageText" slot-scope="props">
                                    <div v-if="!getIsAssessmentListTotalLoading">
                                        {{ props.pageStart }} - {{ props.pageStop }} {{text("api.summary.list.pagination.of")}}
                                        {{ props.itemsLength }}
                                    </div>
                                    <v-progress-circular
                                        v-else
                                        indeterminate
                                        size="20"
                                    ></v-progress-circular>
                                </template>
                            </v-data-table>

                        </v-card>
                    </v-flex>
                </v-layout>
            </div>

        </v-container>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
    </div>
</template>



<!-- ################################################################## -->

<script>

    import { mapGetters } from 'vuex';
    import HeaderBar from "../shared/HeaderBar"
    import TopBar from '../../../common/components/shared/TopBar';
    import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
    import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
    import Vue from "vue";

    export default {
        name: "assessments-list-page",
        components: {
            HeaderBar,
            TopBar,
            AcceptCookie,
            DetectBrowserCookie
        },

        data () {
            return {
                rowsPerPageDropdownOptions: [10, 25],
                headers: [
                    { text: "api.summary.communication.assessment.number", value: 'token', align: 'right', sortable: false },
                    { text: "api.summary.list.column.recdate", value: 'date', align: 'right' },
                    { text: "api.summary.list.column.product", value: 'productName', align: 'right' },
                    { text: "api.summary.list.column.pid", value: 'pid', align: 'right' },
                    { text: "api.summary.communication.user.name.first", value: 'userFirstName', align: 'right' },
                    { text: "api.summary.communication.user.name.last", value: 'userLastName', align: 'right' },
                    { text: "api.summary.communication.user.institution", value: 'userInstitution', align: 'right' },
                ],
                isOpenSearchDateCalendar: false,
                debounceTimeoutId: null,
                inputDebounceDelay: 800, // milliseconds
                sortUpRedPlugin: Vue.SortUpRed.SortUpRedSvg,
                clearRedPlugin: Vue.ClearRed.ClearRedSvg
            }
        },

        computed: {

            ...mapGetters({
                getAssessmentList: 'AssessmentListStore/getAssessmentList',
                getIsAssessmentListDataLoading: 'AssessmentListStore/getIsAssessmentListDataLoading',
                getIsAssessmentListTotalLoading: 'AssessmentListStore/getIsAssessmentListTotalLoading',
                getAssessmentListTotalLength: 'AssessmentListStore/getAssessmentListTotalLength',
                getLastClickedAssessmentId: 'AssessmentListStore/getLastClickedAssessmentId',
                getSearchCriteria: 'AssessmentListStore/getSearchCriteria',
                getMsitat: 'AssessmentListStore/getMsitat',
                getUserData: 'UserStore/getUserData',
                getTranslationTexts: 'TranslationStore/getTexts',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor',
            }),

            translatedHeaders () {

                let newHeaderList = [];
                if (Object.keys(this.getTranslationTexts).length > 0) {
                    newHeaderList = this.headers.map((crtHeaderObj) => {
                        if (crtHeaderObj.text !== "") {
                            crtHeaderObj.text = this.text(crtHeaderObj.text);
                        }
                        return crtHeaderObj;
                    });
                }

                return newHeaderList;
            },

            pagination: {
                get () {
                    return this.$store.getters['AssessmentListStore/getPagination'];
                },
                set (newVal) {
                    this.$store.commit('AssessmentListStore/setPagination', newVal);
                }
            },

            searchDate () {
                return this.getSearchCriteria.date;
            },

            searchDateFormattedForDatepicker: {
                get () {
                    return (!this.getSearchCriteria.date) ? "" : this.resetDateFormat(this.getSearchCriteria.date);
                },
                set (newVal) {
                    console.log('Date picker submit value');
                    this.applySearchFieldChange('date', this.formatDate(newVal));
                }
            },

            // msitat: {
            //     get () {
            //         return this.$store.state["AssessmentListStore"].msitat;
            //     },
            //     set (newFieldValue) {
            //         let trimmedMsitatFieldValue = newFieldValue.trim();
            //         this.$store.commit('AssessmentListStore/setMsitat', trimmedMsitatFieldValue);
            //
            //         this.$store.commit("AssessmentListStore/setPage", 1);
            //         this.$store.dispatch("AssessmentListStore/loadAssessmentListData").then((ajaxResponse) => {
            //             // When we have MSITAT set and there is only a single row in the table, automatically go to it's corresponding Summary page.
            //             if (this.msitat.length > 0 && this.getAssessmentList.length === 1) {
            //                 this.$store.commit("AssessmentListStore/setLastClickedAssessmentId", this.getAssessmentList[0].id); // In fact, it wasn't a real click, but we just suppose it was.
            //                 this.$router.push("/summary?assessmentId=" + this.getAssessmentList[0].id);
            //             }
            //         });
            //     }
            // }
        },


        watch: {
            pagination (newVal, oldVal) {

               // this.$store.commit("AssessmentListStore/setIsAssessmentListDataLoading", true);
                // When watching objects, Vue seems to trigger sometimes the watcher even if the object is unchanged.
                // So we manually check object's properties to see if they have been really changed or not.
                if (newVal.descending === oldVal.descending
                        && newVal.page === oldVal.page
                        && newVal.rowsPerPage === oldVal.rowsPerPage
                        && newVal.sortBy === oldVal.sortBy) { // && newVal.totalItems === oldVal.totalItems
                    return;
                } else {

                    if (newVal.sortBy !== oldVal.sortBy || newVal.descending !== oldVal.descending) {
                        // When sorting was changed, jump to first page.
                        this.$store.commit("AssessmentListStore/setPage", 1);
                    }
                    this.$store.dispatch("AssessmentListStore/loadAssessmentListData").then(() => {
                        this.showSortUpIcon();
                    });

                    // makes sure that when a user come back to page 1 the total count gets updated,
                    // , there maybe new assessments coming in. the case where it is more new assessments,
                    // than one page size will be accepted.
                    if(newVal.page === 1){
                        this.$store.dispatch("AssessmentListStore/loadAssessmentCount")
                    }
                }
            },

            getAssessmentList(newVal, oldVal) {
                if(newVal) {
                    this.showClearIcon()
                }
            }
        },


        beforeCreate() {
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "summary") {
                // Do nothing for now. Do not reset the store when coming back from Summary page
                //                  and the assessment list is not empty (if empty, we will load it from the server).
            }
            else {
                this.$store.commit("AssessmentListStore/resetStore");
            }
        },


        created () {

            if (typeof this.$route.query.msitat !== "undefined") {
                this.$store.commit("AssessmentListStore/setMsitat", this.$route.query.msitat);
            }

            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "summary") {
                if (typeof this.$route.query.msitat !== "undefined") {
                    this.$router.replace({
                        ...this.$router.currentRoute, // name: "AssessmentListPage",
                        query: {
                            'msitat': this.$route.query.msitat,
                            'referral': undefined
                        }
                    })
                }
                else {
                    this.$router.replace({
                        'referral': null
                    });
                }

                if (typeof this.getAssessmentList === "undefined" || this.getAssessmentList.length === 0) {
                    // Usually, when coming back from Summary page we don't reload assessment list from the server.
                    // But sometimes we need to do this (i.e. when the user has reloaded Summary page, stores are cleaned up,
                    // so we need to reload assessment list).
                    this.$store.commit("AssessmentListStore/resetStore");
                    this.$store.dispatch("AssessmentListStore/loadAssessmentListData").then((ajaxResponse) => {
                        // When we have MSITAT set and there is only a single row in the table, automatically go to it's corresponding Summary page.
                        if (this.getMsitat.length > 0 && this.getAssessmentList.length === 1) {
                            this.goToSummaryPage(this.getAssessmentList[0]);
                        }
                    });
                    this.$store.dispatch("AssessmentListStore/loadAssessmentCount")
                        //.then(()=>{console.log("updated total assessments")})
                }
            }
            else {
                this.$store.dispatch("AssessmentListStore/loadAssessmentListData").then((ajaxResponse) => {
                    // When we have MSITAT set and there is only a single row in the table, automatically go to it's corresponding Summary page.
                    if (this.getMsitat.length > 0 && this.getAssessmentList.length === 1) {
                        this.goToSummaryPage(this.getAssessmentList[0]);
                    }
                });
                this.$store.dispatch("AssessmentListStore/loadAssessmentCount")
                    //.then(()=>{console.log("updated total assessments")})
            }
        },

        mounted() {

            this.showSortUpIcon();
        },

        methods: {

            // --------------------------------------
            // --------- Component methods. ---------
            // --------------------------------------

            goToSummaryPage(assessment) {
                this.$store.commit("AssessmentListStore/setLastClickedAssessmentId", assessment.id);

                let summaryPageUrl = "/summary?assessment=" + assessment.token + "&version=" + assessment.version;
                if (this.getMsitat.length > 0) {
                    summaryPageUrl = summaryPageUrl + "&msitat=" + this.getMsitat;
                }
                summaryPageUrl = summaryPageUrl + "&back=true";

                this.$router.push(summaryPageUrl);
            },

            /**
             * Sort assessment list by another column or just toggle ordering if column is unchanged.
             * @param {String} columnKey - Column (field) identifier.
             * @return {Void}
             */
            changeSort (column) {

                if (column === '') {
                    return;
                }

                let pagination = {...this.pagination};

                if (pagination.sortBy === column) {
                    pagination.descending = !pagination.descending;
                } else {
                    pagination.sortBy = column;
                    pagination.descending = false;
                }

                this.$store.commit("AssessmentListStore/setPagination", pagination);
            },

            /**
             * Save new filter value to the store, then reload assessments data from API using new filter value.
             * @param {String} columnKey - Column (field) identifier.
             * @param {String} newInputValue - Input's value after it has been changed.
             * @return {Void}
             */
            applySearchFieldChange(columnKey, newInputValue) {

                // Save new input value to store.
                this.$store.commit('AssessmentListStore/setSearchCriterionByColumn', {
                    columnKey: columnKey,
                    newValue: newInputValue
                });

                // Submit search.
                this.submitSearch();
            },

            /**
             * Postpone the execution of applySearchFieldChange() until after wait milliseconds (set as "inputDebounceDelay" data) have elapsed since the last time it was called.
             *      So only submit search when the user has finished typing in the input.
             * @param {String} columnKey - Column (field) identifier
             * @param {String} newInputValue - Input's value after it has been changed.
             * @return {Void}
             */
            applySearchFieldChangeDebounced(columnKey, newInputValue) {

                if (this.debounceTimeoutId) {
                    clearTimeout(this.debounceTimeoutId);
                    this.debounceTimeoutId = null;
                }

                this.debounceTimeoutId = setTimeout(() => {
                    this.applySearchFieldChange(columnKey, newInputValue);
                }, this.inputDebounceDelay);
            },


            /**
             * Tells the store to load new data from API, based on current filters (if any).
             * @return {Void}
             */
            submitSearch() {

                this.$store.commit("AssessmentListStore/setPage", 1);
                this.$store.dispatch("AssessmentListStore/loadAssessmentListData");
                this.$store.dispatch("AssessmentListStore/loadAssessmentCount")
            },

            submitSearchByMsitat(keyupEvent) {

                let msitatInputValue = keyupEvent.target.value;
                let trimmedMsitatInputValue = msitatInputValue.trim();
                this.$store.commit('AssessmentListStore/setMsitat', trimmedMsitatInputValue);

                this.$store.commit("AssessmentListStore/setPage", 1);
                this.$store.dispatch("AssessmentListStore/loadAssessmentListData").then((ajaxResponse) => {
                    // When we have MSITAT set and there is only a single row in the table, automatically go to it's corresponding Summary page.
                    if (this.getMsitat.length > 0 && this.getAssessmentList.length === 1) {
                        this.$store.commit("AssessmentListStore/setLastClickedAssessmentId", this.getAssessmentList[0].id); // In fact, it wasn't a real click, but we just suppose it was.
                        this.goToSummaryPage(this.getAssessmentList[0]);
                    }
                });
                this.$store.dispatch("AssessmentListStore/loadAssessmentCount")
            },


            /**
             * Clear the search input's value for given field (column).
             * @param {String} - Column's/field's identifier.
             * @return {Void}
             */
            clearSearchFieldValue(columnKey) {
                // Clear the field.
                if (this.getSearchCriteria[columnKey].length > 0) {
                    this.applySearchFieldChange(columnKey, "");
                }
            },

            /**
             * Transforms a date string formatted as "yyyy-mm-dd" into a date string formatted as "dd.mm.yyyy". This is the opposite of resetDateFormat().
             * @param {String} dateString - Date to be formatted.
             * @return {String} - "dd.mm.yyyy" formatted date string.
             */
            formatDate (dateString) {
                if (!dateString) {
                    return '';
                }
                const [year, month, day] = dateString.split('-');

                return `${day}.${month}.${year}`;
            },

            /**
             * Transforms a date string formatted as "dd.mm.yyyy" into a date string formatted as "yyyy-mm-dd". This is the opposite of formatDate().
             * @param {String} dateString - Date to be formatted.
             * @return {String} - "yyyy-mm-dd" formatted date string.
             */
            resetDateFormat (dateString) {
                if (!dateString) {
                    return '';
                }
                const [day, month, year] = dateString.split('.');

                return `${year}-${month}-${day}`;
            },

            addColorBorder() {
                let that = this;
                setTimeout(function(){
                    if (that.$refs.msitat.$el.classList.contains('input-group--focused')) {
                        let themeColor = that.getCurrentGuiThemeColor;
                        that.$refs.msitat.$el.style.setProperty("border", '1px solid' + themeColor, "important");
                    }
                }, 100);
            },
            removeColorBorder() {
                this.$refs.msitat.$el.style.setProperty("border", '1px solid #D4D6D7', "important");
            },

            showClearIcon() {

                let activeColumn = document.querySelectorAll('.assessment-list-table-container .datatable');
                if(activeColumn.length > 0) {
                        let selectedSearch = activeColumn[0].querySelectorAll('.input-group.input-group--append-icon.input-group--text-field:not(.is-empty)');
                        for (let i = 0; i < selectedSearch.length; i++) {
                            let activeSearch = selectedSearch[i].getElementsByClassName('input-group__icon-cb');
                            activeSearch[0].innerHTML = this.clearRedPlugin();

                        }

                        let selectedSearchRemove = activeColumn[0].querySelectorAll('.is-empty');

                        for (let i = 0; i < selectedSearchRemove.length; i++) {
                            let activeSearch = selectedSearchRemove[i].getElementsByClassName('input-group__icon-cb');

                            activeSearch[0].innerHTML = '';

                        }
                }

            },

            showSortUpIcon() {
                let activeColumn = document.getElementsByClassName('assessment-list-table-container');
                if(activeColumn.length > 0) {
                    let activeHeader = activeColumn[0].getElementsByClassName('active');
                    let activeElem = activeHeader[0].getElementsByClassName('icon');
                    activeElem[0].innerHTML = this.sortUpRedPlugin();
                }
            }

        }

    }
</script>

<style lang="scss" scoped>


    .assessment-list {
        margin-bottom: 30px;
        padding-top: 0 !important;
    }

    .assessment-list-card {
        /*padding-bottom: 20px;*/
        padding: 20px;
    }

    .last-clicked td {
        background-color: rgb(238, 238, 238);
    }

    .assessment-list-table-container {
        tr th,
        tr td {
            text-align: left;
        }
    }

    .scrolling-content-assessments {
        top: 68px;
        position: fixed;
        margin-left: auto;
        margin-right: auto;
        overflow: auto;
        width: 100%;
        padding-top: 19px;
        bottom: 10px;
        overflow-x: hidden !important;
    }
    @media only screen and (max-width: 600px) {
        .scrolling-content-assessments {
            top: 60px;
        }
    }

    .container.grid-list-xl .layout.assessment-list-page-content.page-content {
        margin-top: 0;
    }


</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-list/AssessmentListPage.vue